import React, { useState } from "react";
import HeaderSegment from "../HeaderSegment";
import ContentCard from "../ContentCard";
import RequestCard from "./components/RequestCard";
import { RequestData } from "./helper";
import { segmentData } from "components/Connect/helper";
import { useUserRequestList } from "hooks/api/useUserRequestList";
import EmptyState from "components/BaseWidgets/emptyState";

function Requests({ filters }) {
  const [searchText, setSearchText] = useState("");
  const [requestType, setRequestType] = useState("Chat");

  const request_type = requestType === "Call" ? 2 : 1;

  const { data, isLoading } = useUserRequestList({
    page: 1,
    limit: 20,
    list_type: filters?.list_type,
    request_type,
    name_search_query:searchText || ""
  });

  // const filteredByTab = RequestData.filter((request) => {
  //   if (tabActive === "all") return true;
  //   return request.status === tabActive;
  // });

  // console.log(data, "");

  // const filteredRequests = filteredByTab.filter(
  //   (request) =>
  //     request.name.toLowerCase().includes(searchText.toLowerCase()) ||
  //     request.status.toLowerCase().includes(searchText.toLowerCase()) ||
  //     request.isRequest.toLowerCase().includes(searchText.toLowerCase())
  // );

  return (
    <div className="flex flex-col gap-6">
      <HeaderSegment data={segmentData.requests} onChange={setRequestType} />
      <ContentCard onSearch={setSearchText}>
        <div className="flex flex-col">
          {isLoading ? (
            <div className="py-6 text-center text-sm text-gray-500">
              Loading requests...
            </div>
           ) : data?.list?.length > 0 ? (
            data.list.map((request, index) => (
              <RequestCard
                key={index}
                name={request.name}
                status={request.status}
                request={request}
                requestType={request_type}
              />
            ))
          ) : (
            <EmptyState />
          )}
        </div>
      </ContentCard>
    </div>
  );
}

export default Requests;
